import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addError } from 'actions'
import { mapLanguageToComponentProps } from 'i18n'
import { actions } from 'react-redux-form'
import { setDefaultCompetencies } from 'admin/actions/competencies'
import Competency from 'components/competency'
import { Button as StyledButton } from 'components/styled/button'
import { Box } from 'components/styled/containers/box'
import { SingleInputForm } from 'components/single-input-form/with-local-form'
import { LoadingIndicator } from 'components/styled/loading-indicator'
import { Body } from 'components/styled/typography'
import styled from 'styled-components'
import * as analytics from 'analytics/performance'

const propTypes = {
  onAdd: PropTypes.func,
  onRate: PropTypes.func,
  onRemove: PropTypes.func,
  i18n: PropTypes.shape({}).isRequired,
  competencies: PropTypes.arrayOf(PropTypes.shape({})),
  competencyNames: PropTypes.arrayOf(PropTypes.shape({})),
  allowEdit: PropTypes.bool,
  positionId: PropTypes.string.isRequired,
  context: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  hideReviews: PropTypes.bool,
}

const defaultProps = {
  onAdd: () => {},
  onRate: () => {},
  onRemove: () => {},
  competencies: [],
  competencyNames: [],
  allowEdit: false,
  context: 'interview',
  hideReviews: false,
}

const StyledFormContainer = styled(Box)`
  width: ${({ theme }) => theme.space.s400};

  ${({ theme }) => theme.mediaQuery.phone} {
    width: 100%;
  }
`
export class Competencies extends Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      fetchingCompetencies: false,
      fetchingDefaults: false,
    }

    this.setDefaultCompetencies = this.setDefaultCompetencies.bind(this)
  }

  setDefaultCompetencies() {
    const { positionId, context } = this.props
    const { dispatch } = this.props
    this.setState({ fetchingDefaults: true })
    return dispatch(setDefaultCompetencies(positionId, context))
      .then(() => this.setState({ fetchingDefaults: false }))
      .catch(error => {
        this.setState({ fetchingDefaults: false })
        dispatch(addError(error))
      })
  }

  locationId() {
    const { context } = this.props
    if (context === 'interview') {
      return 'adminCandidatePage'
    }
    if (context === 'jobAd') {
      return 'adminApplicationPage'
    }
    return 'competencies'
  }

  createCompetenciesList() {
    const { competencies, competencyNames } = this.props
    return competencyNames.map(competencyName => {
      const personCompetency = competencies.find(
        competency => competency.competencyName === competencyName._id
      )

      if (personCompetency) {
        const { rating, userRating } = personCompetency
        return { ...competencyName, rating, userRating }
      }
      return competencyName
    })
  }

  submitRating(competency, value) {
    const { onRate } = this.props
    if (!competency.userRating || competency.userRating !== value) {
      analytics.onClickEvent({
        locationId: this.locationId(),
        id: 'addCompetencyRatingButton',
        properties: { competency: competency.name, value },
      })
      return onRate({ competency, value })
    }
  }

  submitNewCompetency(values) {
    const { onAdd } = this.props
    this.formDispatch(actions.reset('new-competency'))
    if (values.name.length >= 2) {
      this.setState({ fetchingCompetencies: true })
      onAdd(values).then(() => {
        analytics.onClickEvent({
          locationId: this.locationId(),
          id: 'addCompetencyButton',
          properties: {},
        })
        this.setState({ fetchingCompetencies: false })
      })
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch
  }

  renderEdit() {
    const { i18n, allowEdit } = this.props
    const { edit, fetchingCompetencies } = this.state
    const competencies = this.createCompetenciesList()
    const noCompetencies = competencies.length === 0

    if (edit) {
      return (
        <StyledFormContainer mt="s16">
          <SingleInputForm
            formModel="new-competency"
            isLoading={fetchingCompetencies}
            initialState={{ name: '' }}
            getDispatch={dispatch => this.attachDispatch(dispatch)}
            onClick={values => this.submitNewCompetency(values)}
            model=".name"
            type="text"
            placeholder={i18n.competencies.addCompetency}
          />
          <Box mt="s20">
            <StyledButton
              variant="primary"
              text={i18n.competencies.done}
              onClick={() => this.setState({ edit: false })}
            />
          </Box>
        </StyledFormContainer>
      )
    }
    return (
      <div>
        {noCompetencies && allowEdit && (
          <Box mt="s20" mb="s32">
            <Body mb="s20">{i18n.competencies.defaultsDescription}</Body>
            <StyledButton
              onClick={this.setDefaultCompetencies}
              text={i18n.competencies.getDefaults}
              variant="secondary"
              icon
              event={{
                locationId: this.locationId(),
                id: 'setDefaultCompetenciesButton',
                properties: {},
              }}
            />
          </Box>
        )}
        <Box mt="s20">
          <StyledButton
            variant="secondary"
            icon="edit"
            event={{
              locationId: this.locationId(),
              id: 'editCompetenciesButton',
              properties: {},
            }}
            text={
              noCompetencies
                ? i18n.competencies.addCompetency
                : i18n.competencies.edit
            }
            onClick={() => this.setState({ edit: true })}
          />
        </Box>
      </div>
    )
  }

  render() {
    const { onRemove, allowEdit, hideReviews, context } = this.props
    const { edit, fetchingRating, fetchingDefaults } = this.state
    const competencies = this.createCompetenciesList()
    if (fetchingDefaults) {
      return (
        <div className="competencies">
            <LoadingIndicator centerize={false} size="s24" />
        </div>
      )
    }
    return (
      <div className="competencies">
        <div className="competencies-list">
          {competencies.map(competency => (
            <Competency
              key={competency._id}
              fetching={fetchingRating}
              competency={competency}
              onSubmit={value => this.submitRating(competency, value)}
              onRemove={edit ? () => onRemove(competency) : false}
              hideReviews={hideReviews}
            />
          ))}
        </div>
        {allowEdit && this.renderEdit()}
      </div>
    )
  }
}

Competencies.propTypes = propTypes
Competencies.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(Competencies)
